export const getDefaultCostOfExtras = (tiers: any, isLegal: boolean) => {
  const arrayOfPrices = [...tiers.map((tier: any) => (tier ? tier.amountInPounds : 0))]
  if (isLegal) {
    // gets the max price because you dont want to render free legal as the default price
    return Math.max(...arrayOfPrices).toFixed(2)
  }

  return Math.min(...arrayOfPrices).toFixed(2)
}
